import { pwaInstallHandler } from 'pwa-install-handler';
import React from 'react';

function usePWAInstall() {
    var _a = React.useState(false), canInstall = _a[0], setCanInstall = _a[1];
    React.useEffect(function () {
        pwaInstallHandler.addListener(setCanInstall);
        return function () {
            pwaInstallHandler.removeListener(setCanInstall);
        };
    }, []);
    return canInstall ? pwaInstallHandler.install : null;
}

export { usePWAInstall };
//# sourceMappingURL=index.es.js.map
